export const HINT = 'HINT';
export const ESCALATION_REASON = 'ESCALATION_REASON';
export const SPECIALIST_ONLY_HINT = 'SPECIALIST_ONLY_HINT';
export const CHAT_BOT_PARTNER_NOTE = 'CHAT_BOT_PARTNER_NOTE';
